// Standard HTTP Status Codes
export const SUCCESS = 200;
export const CREATED = 201;
export const NO_CONTENT = 204;
export const BAD_REQUEST = 400;
export const UNAUTHORIZED = 401;
export const GENERAL_FORBIDDEN = 403;
// action was already performed, nothing was changed
export const NOTHING_CHANGED = 208;
// XXX DO NOT USE THIS - use a specific code
export const DO_NOT_USE___NOT_FOUND___DO_NOT_USE = 404;
export const CONFLICT = 409;
export const PRECONDITION_FAILED = 412;
export const TOO_EARLY = 425;
export const TOO_MANY_REQUESTS = 429;

// Custom HTTP Status Codes
export const TOKEN_EXPIRED = 405;
export const CONFIRMATION_EMAIL_SENT = 210;
export const USER_NOT_FOUND = 406;
export const BUDGET_NOT_ENOUGH = 410;
export const OUT_OF_BUSINESS_HOURS = 473;
export const BUYER_CREDIT_CARD_NOT_FOUND = 412;
export const LEAD_MISSING_CATEGORY = 413;
export const USER_MISSING_CATEGORY = 418;
export const LEAD_NOT_REASSIGNABLE = 414;
export const CANNOT_REMOVE_CATEGORY = 414;
export const LEAD_MISSING_A_BID = 415;
export const RESPONSE_TIMEOUT = 450;
export const PRECONDITION_FAILURE = 451;
export const NOT_ENOUGH_BUDGET_TO_MATCH_BID = 452;
export const MISSING_SUBSCRIPTION = 453;
export const MISSING_REP_ID = 454

export const AUTH_CODE_EXPIRED = 460;
export const AUTH_CODE_MISMATCH = 461;
export const USER_ALREADY_REGISTERED = 462;
export const INVALID_PHONE_NUMBER = 463;
export const LINK_EXPIRED_OR_USED = 464;
export const CHARGE_FAILURE = 464;
export const SUBSCRIPTION_FAILURE = 465;
export const REFERRAL_CODE_ALREADY_EXISTS = 466;
export const PAYMENT_DETAILS_REQUIRED = 467;
export const USER_HAS_FAILING_TRANSACTIONS = 468;
export const LEAD_SOURCE_NOT_FOUND = 469;
export const LEAD_MANAGER_NOT_FOUND = 470;
export const CAMPAIGN_NOT_FOUND = 471;
export const USER_ACCOUNT_BLOCKED = 472;

export const COUNTY_OR_STATE_NOT_FOUND = 414;
// XXX DO NOT USE THIS - use a specific code
export const DO_NOT_USE___GENERIC_ERROR___DO_NOT_USE = 500;
export const SENT_DATE_IN_PAST = 501;
export const LEAD_ALREADY_PAID = 502;
export const ERROR_CREATING_COUNTY_BID = 503;
export const ERROR_UPDATING_LEAD = 504;
export const ERROR_CALCULATING_BUDGET = 508;
export const PAYMENT_METHOD_FAILURE = 505;
export const FAILED_TO_NOTIFY_RECIPIENT = 508;
export const INCOMPLETE_ACTION_FAILURE = 509;
export const UNEXPECTED_FAILURE = 510;

// You can add other custom statuses as needed, ensuring they don't overlap with standard codes.

/**
 * Statuses that represent a deliberate, handled business rejection rather than a fault: the request
 * reached the right place, a rule said no, and the client is shown a message. These are logged at
 * `warn` by the request logger instead of `error`, which keeps them out of Sentry (SentryTransport
 * only forwards `error`) while still sending them to the console and BetterStack.
 *
 * Every other status >= 400 still logs at `error`. This list is deliberately minimal - add a status
 * only after confirming that its callers use it for a rule rejection and not for a fault.
 */
export const EXPECTED_REJECTION_STATUSES: ReadonlySet<number> = new Set([
    CONFLICT, // 409 - e.g. buyer already holds a lead from the same duplicate group (SEL-1209)
]);